export class ThemeColors {
  constructor(
    public main: string,
    public accent: string,
    public fontDark: string,
    public fontLight: string,
    public lightBG: string
  ) { }
}
